<template>
  <nuttrema-layout-form-standard
     class="is-center-padding-top-1em"
    :edit="edit"
    :saveError="InvoiceDetails.saveError">
    <template slot="center">
      <table class="table--invoice-details">
        <thead>
          <tr>
            <td>
              <nuttrema-invoice-address
                :Person="_get(InvoiceDetails, 'data.Seller')"
                :PersonInstance="_get(InvoiceDetails, 'data.SellerInstance')">
              </nuttrema-invoice-address>
            </td>
          </tr>
          <tr>
            <td class="is-vertical-space"></td>
          </tr>
          <tr>
            <td>
              <nuttrema-invoice-address
                 text-align="right"
                :title="$t('label.billed_to')"
                :Person="_get(InvoiceDetails, 'data.Buyer')"
                :PersonInstance="_get(InvoiceDetails, 'data.BuyerInstance')">
              </nuttrema-invoice-address>
            </td>
          </tr>
          <tr>
            <td class="is-vertical-space"></td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <table class="table--invoice-type-no">
                <tr>
                  <td width="50%">
                    {{ $t(`label.${_get(InvoiceDetails, 'data.invoice_type')}`) }}:
                  </td>
                  <td class="is-align-right">
                    {{ _get(InvoiceDetails, 'data.formatted_no') }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td class="is-vertical-space"></td>
          </tr>

          <tr>
            <td>
              <table class="table--issue-date-status">
                <tr>
                  <td class="is-align-right">
                    {{ $t('label.issue_date') }}: <strong>{{ _get(InvoiceDetails, 'data.issue_date') | moment('ll') }}</strong>
                  </td>
                </tr>
                <tr>
                  <td class="is-align-right">
                    {{ $t('label.status') }}: <strong>{{ $t(`label.${_get(InvoiceDetails, 'data.status')}`) }}</strong>
                  </td>
                </tr>
                <tr v-if="_get(InvoiceDetails, 'data.Purchase.processor')">
                  <td class="is-align-right">
                    {{ $t('label.payment_processor') }}: <strong>{{ $t(`label.${_get(InvoiceDetails, 'data.Purchase.processor')}`) }}</strong>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td class="is-vertical-space"></td>
          </tr>

          <tr>
            <td>
              <table class="table--invoice-items">
                <thead>
                  <tr>
                    <th width="75%">{{ $t('label.description') }}</th>
                    <th class="is-align-right">{{ $t('label.amount') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in _get(InvoiceDetails, 'data.InvoiceItems', [])">
                    <tr>
                      <td>{{ _get(item, 'description') }}</td>
                      <td class="is-align-right">{{ _get(item, 'pre_tax_amount') | number-format(2, false, true) }} {{ _get(InvoiceDetails, 'data.Currency.symbol', '') }}</td>
                    </tr>
                    <template v-if="_get(item, 'SubItems', []).length > 0">
                      <tr>
                        <td>
                          <template v-if="options.showExtraOptions">
                            {{ $t('label.extra_options') }}
                          </template>

                          <template v-else>
                            <nuttrema-show-hide-button :state.sync="options.showExtraOptions"></nuttrema-show-hide-button>
                            <span style="float:right; font-weight: 600;">
                              {{ $t('label.extra_options_total') }}
                            </span>
                          </template>
                        </td>
                        <td class="is-align-right">
                          <span v-show="!options.showExtraOptions">{{ extraOptionsTotal | number-format(2, false, true) }} {{ _get(InvoiceDetails, 'data.Currency.symbol', '') }}</span>
                        </td>
                      </tr>
                      <tr v-for="feature in _get(item, 'SubItems', [])" v-if="options.showExtraOptions" class="extra-option">
                        <td>{{ _get(feature, 'description') }}</td>
                        <td class="is-align-right">{{ _get(feature, 'pre_tax_amount') | number-format(2, false, true) }} {{ _get(InvoiceDetails, 'data.Currency.symbol', '') }}</td>
                      </tr>
                    </template>
                  </template>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td>
              <table class="table--invoice-total">
                <tr v-if="options.showExtraOptions">
                  <td width="75%" class="is-text">
                    <nuttrema-show-hide-button :state.sync="options.showExtraOptions" style="font-weight: normal; float: left;"></nuttrema-show-hide-button>
                    {{ $t('label.extra_options_total') }}
                  </td>
                  <td>
                    {{ extraOptionsTotal | number-format(2, false, true) }} {{ _get(InvoiceDetails, 'data.Currency.symbol', '') }}
                  </td>
                </tr>
                <tr>
                  <td width="75%" class="is-text">
                    {{ $t('label.sub_total') }}
                  </td>
                  <td>{{ _get(InvoiceDetails, 'data.pre_tax_total', 0) | number-format(2, false, true) }} {{ _get(InvoiceDetails, 'data.Currency.symbol', '') }}</td>
                </tr>
                <tr>
                  <td class="is-text">
                    <span v-if="_get(InvoiceDetails, 'data.total_tax', 0) > 0">{{ $t('label.vat') }}* {{ `(${TAX.EU}%)` }}</span>
                    <span v-else>{{ $t('label.vat') }}</span>
                  </td>
                  <td>{{ _get(InvoiceDetails, 'data.total_tax', 0) | number-format(2, false, true) }} {{ _get(InvoiceDetails, 'data.Currency.symbol', '') }}</td>
                </tr>
                <tr>
                  <td class="is-text is-total">
                    {{ $t('label.total') | uppercase }}
                  </td>
                  <td class="is-total">{{ _get(InvoiceDetails, 'data.total', 0) | number-format(2, false, true) }} {{ _get(InvoiceDetails, 'data.Currency.symbol', '') }}</td>
                </tr>
              </table>
            </td>
          </tr>

          <tr v-if="_get(InvoiceDetails, 'data.total_tax', 0) > 0">
            <td>
              <table class="table--invoice-note">
                <tr>
                  <td>* {{ $t('label.vat_help') }}</td>
                </tr>
              </table>
            </td>
          </tr>

        </tbody>
      </table>

    </template>

    <div slot="footer">
      <template v-if="!options.showConfirmPayment">
        <div class="footer-row" >
          <div class="footer-row__column">
            <el-button
               v-if="isActionAllowed('confirm')"
               type="primary"
               size="small"
              :loading="options.action === 'confirmPayment' && isSaving"
              @click="options.showConfirmPayment = true">
              {{ $t('label.confirm_payment') }}
            </el-button>

            <el-button
               v-if="isActionAllowed('deny')"
               type="warning"
               size="small"
              :loading="options.action === 'denyPayment' && isSaving"
              @click="handleDenyPayment">
              {{ $t('label.deny_payment') }}
            </el-button>

            <el-button
               v-if="isActionAllowed('cancel')"
               type="warning"
               size="small"
              :loading="options.action === 'cancelPayment' && isSaving"
              @click="handleCancelPayment">
              {{ $t('label.cancel_payment') }}
            </el-button>
          </div>

          <div class="footer-row__column">
            <el-button type="text" size="small" @click="cancelChanges">
              <span v-if="showDoneButton">{{ $t('label.done') }}</span>
              <span v-else>{{ $t('label.cancel') }}</span>
            </el-button>
          </div>
        </div>
      </template>

      <template v-if="options.showConfirmPayment">
        <el-form
          :ref="formRef"
          :rules="rules"
          :model="formData"
          :validate-on-rule-change="false">
        <div class="footer-row">
          <div class="el-col" span="12">
            <el-form-item prop="transaction_ref">
              <el-input :placeholder="`${$t('label.transaction_reference')}*`" v-model="formData.transaction_ref" class="w-100" size="small"></el-input>
            </el-form-item>
          </div>
          <div class="el-col" span="6">
            <el-form-item>
              <el-button
                 class="w-100"
                 size="small"
                 type="primary"
                :loading="isSaving"
                @click="handleConfirmPayment">
                {{ $t('label.confirm') }}
              </el-button>
            </el-form-item>
          </div>
          <div class="el-col" span="6">
            <el-form-item>
              <el-button class="el-button--cancel-action" size="small" type="text" @click="options.showConfirmPayment = false">{{ $t('label.cancel_the_action') }}</el-button>
            </el-form-item>
          </div>
        </div>
        </el-form>
      </template>

    </div>

  </nuttrema-layout-form-standard>
</template>

<script>
import { get, includes, each } from 'lodash';
import { TAX } from 'constants/values';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import NuttremaInvoiceAddress from 'components/ui/info/nuttrema-invoice-address';
import NuttremaShowHideButton from 'components/ui/button/nuttrema-show-hide-button';

export default {
  name: 'form-sys-admin-instance-subscription-invoice-details',
  mixins: [FormStandardBehavior],
  props: {
    InvoiceDetails: {
      required: true,
      default: null,
    },
    edit: {
      required: false,
      default: false,
    },
  },
  components: {
    NuttremaInvoiceAddress,
    NuttremaShowHideButton,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      TAX,
      formData: {
        transaction_ref: null,
      },
      options: {
        showExtraOptions: false,
        showConfirmPayment: false,
        action: null,
      },
    };
  },
  methods: {
    isActionAllowed(action) {
      const paymentActions = get(this.InvoiceDetails, 'data.payment_actions', []);
      return includes(paymentActions, action);
    },
    getFormData() {
      return { transaction_ref: this.formData.transaction_ref };
    },
    submitForm(action, validate = true) {
      this.options.action = action;
      const data = this.getFormData();
      if (validate) {
        this.$refs[this.formRef].validate((valid) => {
          if (valid) {
            this.$emit(action, this.toJSON(data));
          }
          return valid;
        });
      } else {
        this.$emit(action, this.toJSON(data));
      }
    },
    handleConfirmPayment() {
      this.submitForm('confirmPayment');
    },
    handleDenyPayment() {
      this.submitForm('denyPayment', false);
    },
    handleCancelPayment() {
      this.submitForm('cancelPayment', false);
    },
  },
  computed: {
    extraOptionsTotal() {
      let sum = 0;
      const invoiceItems = get(this.InvoiceDetails, 'data.InvoiceItems', []);

      each(invoiceItems, (item) => {
        sum += Number(get(item, 'pre_tax_amount', 0) || 0);
      });

      const preTaxTotal = Number(get(this.InvoiceDetails, 'data.pre_tax_total', 0) || 0);

      return preTaxTotal - sum;
    },
    rules() {
      return {
        transaction_ref: [
          {
            required: this.options.showConfirmPayment,
            message: this.formatValidationMessage('validation.required', 'label.transaction_reference', true),
            trigger: 'blur',
          },
        ],
      };
    },
  },
  created() {
    this.stateData = this.InvoiceDetails;
    this.formRef = 'form-sys-admin-instance-subscription-invoice-details';
  },
};
</script>

<style lang="scss" scoped>
  .is-align-right {
    text-align: right;
  }

  .is-vertical-space {
    height: 1em;
  }

  .is-border-bottom-line {
    border-bottom: 1px solid #c8d0e1;
  }

  .el-button--cancel-action {
    // padding-top: 0;
    // font-size: 0.85em;
    color: #9E9E9E;
  }

  .table--invoice-details {
    thead, tbody {
      tr {
        td, th {
        }
      }
    }
  } // end ~ table--invoice-details

  .table--invoice-type-no {
    tr {
      td {
        padding: 0.5em 0.25em;
        font-weight: 800;
        font-size: 1.15em;
        border-top: 1px solid #c8d0e1;
        border-bottom: 1px solid #c8d0e1;
      }
    }
  } // end ~ table--invoice-type-no

  .table--issue-date-status {
    tr {
      td {
        padding: 0.15em 0.25em;
      }
    }
  } // end ~ table--invoice-type-no

  .table--invoice-items {
    thead {
      tr {
        th {
          padding: 0.25em 0.35em;
          background-color: rgba(#c8d0e1, 0.25);
        }
      }
    }
    tbody {
      tr {
        td {
          font-size: 0.9em;
          padding: 0.35em 0.35em;
          border-bottom: 1px solid #c8d0e1;
        }
        &.extra-option {
          td {
            font-size: 0.85em;
            padding: 0.25em 0.35em 0.25em 1em;
          }
        }
      }
    }
  } // end ~ table-invoice-items

  .table--invoice-note {
    td {
      padding: 0.35em;
      font-size: 0.8em;
    }
  }

  .table--invoice-total {
    tr {
      td {
        padding: 0.35em;
        font-size: 0.9em;
        text-align: right;
        border-bottom: 1px solid #c8d0e1;

        &.is-text {
          font-weight: 600;
        }

        &.is-sub-total {
          border-top: 2px solid #c8d0e1;
        }

        &.is-total {
          font-weight: 600;
          font-size: 1.1em;
          border-top: 2px solid #c8d0e1;
          border-bottom: 2px solid #c8d0e1;
        }
      }

      // &:last-child {
      //   td {
      //     border-bottom: none;
      //   }
      // }
    }
  } // end ~ table--invoice-total
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/shared/instance-subscriptions/details/form-instance-invoice-details.vue